document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('.product-media-modal');

  if (!modal) return;

  const mediaItems = Array.from(
    modal.querySelectorAll('[data-media-id]')
  );

  if (mediaItems.length < 2) return;

  const dialog = modal.querySelector('[role="dialog"]');

  if (!dialog) return;

  // Create navigation buttons
  const prev = document.createElement('button');
  const next = document.createElement('button');

  prev.className = 'custom-media-prev';
  next.className = 'custom-media-next';

  prev.setAttribute('aria-label', 'Previous image');
  next.setAttribute('aria-label', 'Next image');

  prev.innerHTML = '&#10094;';
  next.innerHTML = '&#10095;';

  dialog.appendChild(prev);
  dialog.appendChild(next);

  let currentIndex = 0;

  function showImage(index) {
    currentIndex = (index + mediaItems.length) % mediaItems.length;

    const item = mediaItems[currentIndex];

    item.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }

  prev.addEventListener('click', (event) => {
    event.stopPropagation();
    showImage(currentIndex - 1);
  });

  next.addEventListener('click', (event) => {
    event.stopPropagation();
    showImage(currentIndex + 1);
  });

  document.addEventListener('keydown', (event) => {
    if (!modal.hasAttribute('open')) return;

    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      showImage(currentIndex - 1);
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      showImage(currentIndex + 1);
    }
  });
});